import { useEffect } from "react";
import { useConsent } from "../context/ConsentContext";
import { loadScript } from "../utils/loadScript";

// GA ID for Google Analytics 4
const GA_ID = "G-ENPRD8KHEF";

export default function AnalyticsLoader() {
  const { consent } = useConsent();

  useEffect(() => {
    if (consent !== "accepted") return;

    loadScript(`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`, "ga-script");

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag("js", new Date());
    gtag("config", GA_ID, {
      anonymize_ip: true, // extra privacy-friendly default
    });
  }, [consent]);

  return null;
}